import { render } from "./SuccessIcon.vue?vue&type=template&id=844b461e"
import script from "./SuccessIcon.vue?vue&type=script&lang=js"
export * from "./SuccessIcon.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__